import { Spinner } from "@blueprintjs/core";

import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { GREEN, MIDTEXT_COLOR, SUBTEXT_COLOR } from "@/css/constants";
import { ReferralUser } from "@/types/users";
import { ensureNonNullArray } from "@/utils/array";
import { formatDate } from "@/utils/datetime";
import { NonNullableArrayItem } from "@/utils/types";

type Referral = NonNullableArrayItem<ReferralUser["referrals"]>;

export function ReferralList({ user }: { user?: ReferralUser | null }) {
  function getTags(referral: Referral) {
    const credits = referral.referralBonusPaid
      ? 0.25
      : referral.acquisitionBonusPaidAmount || 0;
    if (credits) {
      return (
        <Box
          px={2}
          py={1}
          backgroundColor={GREEN}
          className="round-corners"
          color="#FFF"
        >
          <Flex alignItems="center">
            <EmbedSvg src={CreditSVG} height={18} width={18} />
            <Box ml={2}>{credits}</Box>
          </Flex>
        </Box>
      );
    }

    return (
      <Box
        px={2}
        py={1}
        backgroundColor={MIDTEXT_COLOR}
        className="round-corners"
        color="#FFF"
      >
        Pending
      </Box>
    );
  }

  const referrals = ensureNonNullArray(user?.referrals);

  return (
    <>
      <Box fontSize={22} fontWeight={600}>
        Your Referrals
      </Box>
      <Box mt={2} fontSize={16} color={SUBTEXT_COLOR}>
        For privacy reasons, we don't reveal the names of the accounts you have
        referred
      </Box>
      <Box mt={3} backgroundColor="#FFF">
        {referrals ? (
          <>
            {referrals.map((referral, idx) => {
              return (
                <Flex
                  key={referral.id}
                  alignItems="center"
                  justifyContent="space-between"
                  py={3}
                >
                  <div>
                    <div>
                      Referral #{referrals.length - idx} (
                      {referral.referralType})
                    </div>
                    <div style={{ color: SUBTEXT_COLOR }}>
                      {formatDate(referral.createdAt, "MMM d, yyyy")}
                    </div>
                  </div>
                  <div>{getTags(referral)}</div>
                </Flex>
              );
            })}
          </>
        ) : (
          <Spinner size={24} />
        )}
        {referrals && !referrals.length ? "No referrals yet" : null}
      </Box>
    </>
  );
}
